export default __webpack_public_path__ + "static/media/font1.31b9066b.svg";